module.exports = __webpack_public_path__ + "img/dsn02.aa86935f.gif";